export const displayMaxAmountOfTags: number = 5;
export const webServiceTranslationPrefix: string = 'shop.accordion.apiUsers.webservices';
export const userAdministrationPath: string = '/users';
export const validUsername = /^[a-zA-Z0-9._-]+$/;
export const toastDelayMs: number = 3000;
